<template>
  <table class="shares-table">
    <tbody>
      <tr v-for="(share, index) in shares" :key="index">
        <td>{{ share.useTypeName }}</td>
        <td class="ml-2 text-right">{{ share.split }}%</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "InterestedPartySharesTable",
  props: {
    shares: {
      type: Array,
      required: true,
      validator (value) {
        return value && Array.isArray(value)
      },
    },
  },
}
</script>

<style scoped>
.shares-table td {
  padding: 0 0 0.5rem;
  border-top: none;
}

.shares-table tbody tr {
  background: none !important;
}

.shares-table tbody tr:hover {
  background: none !important;
}

.shares-table td:last-child {
  padding-left: 0.5rem;
}
</style>
